<template>
    <div class="container-fluid">
        <div class="row py-3 ">
            <div class="designRowOrga w-100">
                <div class="h3Organization w-50">
                    <img src="../../../assets/images/title-icon.png" alt="">
                    <h3>Users</h3>
                </div>
                <div class="right-header-container">
                    <div class="twoInputs">
                        <div class="btnInsideInput w-100">
                            <button @click="searchBackEndHandler(isSearch)" class="search-btn">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search"
                                   @input="searchHandler" maxlength="50">
                        </div>
                    </div>
                    <div class="fullInputs mb-4">
                        <div class="oneInput w-100">
                            <select id="filter_dates" class="form-select" v-model="sort" @change="filterHandler">
                                <option value="" disabled>Sort by Date</option>
                                <option value="asc" key="1">Oldest</option>
                                <option value="desc" key="2">Latest</option>
                            </select>
                        </div>
                    </div>
                    
                    <router-link class="text-decoration-none btn-container"
                                v-if="permissions.includes('create user') && users.length > 0"
                                to="/super/users/create">
                        <span>Create</span>
                    </router-link>
                </div>
            </div>

            <div class="tabcontent tabcontent-bark-mode">
                
                <div class="table-container" v-if="users.length > 0">


                    <TableComponent model="users" name="user" :keys="keys" :thead="thead" :tbody="users"
                                    updateUrl="/super/users/edit"
                                    @sort="SortOrganization"
                                    @update="updateOrganization"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="handlePagination($event)" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>
                <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
                    <div class="no-data-header-container">
                        <h3 class="no-data-header" v-if="!isSearch">You Don't Have Any Users Yet</h3>
                        <h3 v-else>No Data</h3>
                    </div>
                    <router-link class="text-decoration-none btn-container  btn-container-no-data"
                                 v-if="permissions.includes('create user') && users.length === 0 && !isSearch"
                                 to="/super/users/create">
                        <span>Create User</span>
                    </router-link>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
    import repository from "../../../api-services/repository";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import TableComponent from "../../components/TableComponent";

    export default {
        name: 'user-superIndex',
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'super-users');
            this.permissions = this.$store.state.auth.permissions;
            this.getUsers();
            this.$store.dispatch('activeTap', 'super-users');
        },
        data() {
            return {
                users: [],
                permissions: [],
                state: false,
                originalUsers: [],
                thead: ['Username', 'User Email'],
                keys: ['name', 'email'],
                laravelData: {},
                search: '',
                isSearch: false,
                sort: 'desc'
            }
        },
        methods: {
            async getUsers(page = 1) {
                try {
                    let usersData = await repository.index('users', this.search, this.sort === false ? this.sort = 'desc' : this.sort, true, page);
                    this.laravelData = usersData.data.data;
                    this.users = usersData.data.data.data;
                    this.originalUsers = usersData.data.data.data;
                } catch (e) {
                    console.log({e})
                }
            },
            searchHandler(e) {
                this.isSearch = true;
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                // searchedData = this.originalUsers.filter((data) => data.name.toLowerCase().indexOf(serachedValue) >= 0 || data.email.toLowerCase().indexOf(serachedValue) >= 0);
                // this.users = searchedData;
                // if (serachedValue !== '') {
                //     this.isSearch = true;
                // } else {
                //     this.isSearch = false;
                // }
            },
            async searchBackEndHandler(searchFlag = false) {
                // let usersDataLength = this.users.length;
                // if (searchFlag && usersDataLength > 0) {
                    await this.getUsers();
                // }
            },
            filterHandler(e) {
                let filterType = e.target.value;
                if (filterType === 'asc') {
                    this.users.sort(function (a, b) {
                        return new Date(a.created_at) - new Date(b.created_at);
                    });
                } else {
                    this.users.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });

                }
            },
            async handlePagination(pageNumber) {
                await this.getUsers(pageNumber);
            },
            SortOrganization() {
                let status = !this.state;
                this.originalUsers.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            },
            updateOrganization(e) {
                let filteredData = this.users.filter(function (data) {
                    return data.id != e;
                });
                this.users = filteredData;
                this.getUsers();
            },
        }
    }
</script>

<style scoped>
    .no-data-header{
        font-size: 18px;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #DDD !important;
        opacity: 0.5 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #DDD !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #DDD !important;
    }
    .create-btn-text{
        font-size: 17px;
    }
    .tabcontent{
        height:73vh;
        padding-top: 0 !important;
        overflow-y: auto;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .h3Organization img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .h3Organization h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        font-size: calc(1.1rem+0.6vw);
    }
    .right-header-container{
        display: flex;
        flex-direction: row;
        justify-content:space-between;
        width:45%;
        height: 35px;
    }
    .right-header-container .btn-container{
        font-size: 16px;
        width: 25%;
        font-weight: normal;
    }
    .twoInputs{
        width:45%;
    }
    .search-btn{
        width: 10%;
        border-radius: 6px 0 0 6px;
        background-color:#707070;
        align-items: center;
        padding-bottom: 3px;
    }
    .btnInsideInput{
        border-radius: 6px;
        background-color: #707070;
    }
    .btnInsideInput input{
        border-radius: 6px;
        background-color: #707070;
        padding-left: 0;
        padding-top: 5px;
        padding-bottom: 0;
        
    }
    .form-control {
        color: white !important;
        display: flex;
        justify-content: left;
        width:90% !important;
        padding-left: 10px !important;
    }
    .designRowOrga{
        padding-left:40px !important;
        padding-right: 40px;
        height: 50px;
        align-items: center;
        margin-bottom: 2%;
    }
    .paginationLink{
        font-size:11px;
        font-weight: bold;
        width:99%;
    }
    .fullInputs{
        width:25%;
        height: 100%;
    }
    .oneInput{
        height: 100%;
    }
    #filter_dates{
        width:100% !important;
        border: none;
        padding:0;
        padding-left: 10px;
        height: 100% !important;
    }
    #free_search::placeholder{
        opacity: 1 !important;
        color: white !important;
        /* font-size: 19px; */
    }
    @media(max-width:1280px){
        .h3Organization{
            width: 40% !important;
        }
        .h3Organization img{
            width: 5vh !important;
        }
        .right-header-container{
            width:60%;
            /* margin-top: 10px; */
        }
        .twoInputs{
            margin-bottom:0 !important;
        }
        .table-container :deep(thead :first-child){
        width:40% !important;
        }
        .tabcontent{
            padding-top: 0 !important;
            overflow-y: scroll;
        }
    }
    @media(max-height:767px){
        .tabcontent{
            height: 69vh;
        }
    }
</style>